'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (handler) {
    document.addEventListener('fullscreenchange', function () {
        return handler(document.fullscreen);
    });
    document.addEventListener('webkitfullscreenchange', function () {
        return handler(document.webkitIsFullScreen);
    });
    document.addEventListener('mozfullscreenchange', function () {
        return handler(document.mozFullScreen);
    });
    document.addEventListener('MSFullscreenChange', function () {
        return handler(document.msFullscreenElement);
    });
};